module.exports = __webpack_public_path__ + "static/media/donor.ec6a53da.png";